<template>
    <div class="ad-container">
<!--        <Adsense-->
<!--                data-ad-client="ca-pub-9818471376153254"-->
<!--                data-ad-slot="8309083986"-->
<!--                data-ad-format="auto"-->
<!--                :data-full-width-responsive="true"-->
<!--        >-->
<!--        </Adsense>-->
    </div>
</template>

<script>
    export default {
        props: {
        },
    };
</script>
